import algoliasearch from "algoliasearch/lite";
import tableSearch from "./../shared/tableSearch/tableSearch.vue";
import ReferalApi from "../../../services/api/referralApi.js";
import RetailerApi from "@/services/api/retailerApi.js";
import BrandApi from "@/services/api/brandApi.js";
import { mapGetters } from "vuex";

const ReferalApiSevice = new ReferalApi(),
  RetailerApiService = new RetailerApi(),
  BrandApiService = new BrandApi();
export default {
  components: {
    tableSearch,
  },

  data() {
    return {
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      query: "",
      isTypingSearchQuery: false,
      results: [],
      pagination: {
        page: 1,
        limit: 12,
        totalCount: 0,
      },
      showPopUp: false,
      retailerName: "",
      brandName: "",
      buttonLoading: false,
    };
  },

  methods: {
    changeStatus,
    load,
    search,
    handleCreateClick,
    close,
    handleRetailerSelectChange,
    handleSBrandSelectChange,
    handleCreateReferralClick,
  },

  beforeMount() {
    this.searchIndexReferrals = this.algoliaClient.initIndex(this.$env.getOrigin() + "_referrals");
    this.load();
  },

  computed: {
    ...mapGetters({
      user: "userState",
    }),
    canSubmit: function () {
      return this.retailerName !== "" && this.brandName !== "";
    },
    brandSelected: function() {
      return this.brandName !== "";
    }

  },
};

function changeStatus(e, index, id) {
  e.preventDefault();
  this.$loader.$emit("trigger", true);

  ReferalApiSevice.changeReferalPaidStatus(id)
    .then(() => {
      this.results[index].completed = !this.results[index].completed;
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$logger.notify(new Error(error));
      }
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
    });
}

function search(val) {
  this.pagination.page = 1;
  this.query = val;
  this.load();
}

function load(page) {
  let _self = this;

  if (page) _self.pagination.page = page;

  _self.results = [];
  _self.$loader.$emit("trigger", true);

  _self.searchIndexReferrals.clearCache();
  _self.searchIndexReferrals
    .search({
      query: _self.query,
      page: _self.pagination.page - 1,
      hitsPerPage: _self.pagination.limit,
      facets: "brand_id",
      facetFilters: [_self.user.role === "BRAND" ? ["brand_id:" + _self.user.brand_id] : []],
    })
    .then((response, err) => {
      if (err) {
        _self.$swal("Attention", _self.$utils.formatErrorMessage("referrals"));
        _self.$logger.notify(new Error(err));

        return;
      }

      _self.results = response.hits;
      _self.pagination.totalCount = response.nbHits;
      _self.$loader.$emit("trigger", false);
    });
}

function handleCreateClick() {
  this.showPopUp = true;
}

function close() {
  this.showPopUp = false;
  this.retailerName = "";
  this.brandName = "";
}

function handleRetailerSelectChange(retailer) {
  this.retailerName = retailer.id;
}

function handleSBrandSelectChange(brand) {
  this.brandName = brand.id;
}

async function handleCreateReferralClick() {
  this.buttonLoading = true;
  try {
    const retailer = await RetailerApiService.getRetailerById(this.retailerName);
    const brand = await BrandApiService.getBrand(this.brandName);
    const { data } = await ReferalApiSevice.createNewReferral(retailer.data.email, brand.data.email);
    if (data.invalid_referrals.length !== 0) {
      this.$swal("attention", "referral relationship already exists");
      this.buttonLoading = false;
    } else {
      setTimeout(() => {
        this.buttonLoading = false;
        this.close();
        this.load();
      }, 4000);
    }
  } catch (err) {
    this.$logger.notify(Error(err));
  }
}
